/**
 * @generated SignedSource<<b056e72aadfd4beba9fa7a15944f13a8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedVideoComponentVideo_componentModule$data = {
  readonly videoAutoplay: boolean | null;
  readonly videoId: string | null;
  readonly " $fragmentType": "HpSharedVideoComponentVideo_componentModule";
};
export type HpSharedVideoComponentVideo_componentModule$key = {
  readonly " $data"?: HpSharedVideoComponentVideo_componentModule$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedVideoComponentVideo_componentModule">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedVideoComponentVideo_componentModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "videoId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "videoAutoplay",
      "storageKey": null
    }
  ],
  "type": "VideoModule",
  "abstractKey": null
};

(node as any).hash = "c0f1211d572af694949601a9e5ef51f9";

export default node;
